import LegacyLoginPersonalDetails from './LegacyLoginPersonalDetails';
import PersonalDetails from './PersonalDetails';
import { useSession } from 'session';
import { LoadingScreen } from 'components/index.ts';

export const PersonalDetailsResolver = () => {
  const authMode = useSession((state) => state.mode);

  if (authMode === null) {
    return <LoadingScreen />;
  }
  return authMode === 'legacy' ? (
    <LegacyLoginPersonalDetails />
  ) : (
    <PersonalDetails />
  );
};
